import Cookies from 'js-cookie'
import { PropsWithChildren, useCallback, useMemo, useState } from 'react'
import {
  SIDEBAR_COLLAPSED_COOKIE_MAX_AGE,
  SIDEBAR_COLLAPSED_COOKIE_NAME,
} from '../constants/sidebar'
import { SidebarContext } from '../contexts/sidebar'

type SidebarProviderProps = PropsWithChildren

export function SidebarProvider({ children }: SidebarProviderProps) {
  const [isCollapsed, _setIsCollapsed] = useState<boolean | undefined>(() => {
    try {
      const cookie = Cookies.get(SIDEBAR_COLLAPSED_COOKIE_NAME)
      return !cookie || cookie === 'true'
    } catch {
      return false
    }
  })
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const setIsCollapsed = useCallback((isCollapsed: boolean) => {
    _setIsCollapsed(isCollapsed)
    Cookies.set(SIDEBAR_COLLAPSED_COOKIE_NAME, isCollapsed.toString(), {
      expires: SIDEBAR_COLLAPSED_COOKIE_MAX_AGE,
    })
  }, [])

  const toggleOpen = useCallback(() => {
    setIsOpen((prev) => !prev)
  }, [])

  const toggleCollapsed = useCallback(() => {
    setIsCollapsed(!isCollapsed)
  }, [isCollapsed, setIsCollapsed])

  const contextValue = useMemo(() => {
    return {
      isOpen,
      isCollapsed,
      setIsCollapsed,
      setIsOpen,
      toggleOpen,
      toggleCollapsed,
    }
  }, [
    isOpen,
    isCollapsed,
    setIsCollapsed,
    setIsOpen,
    toggleOpen,
    toggleCollapsed,
  ])

  return (
    <SidebarContext.Provider value={contextValue}>
      {children}
    </SidebarContext.Provider>
  )
}
